module.exports = __webpack_public_path__ + "assets/img/star_sentence_select9.8f39f0ff.png";